export default __webpack_public_path__ + "static/media/1743.6841eac8.png";